<template>
	<div>
		<a-page-header style="background: #fff;" title="会员管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'会员管理'}]}}">
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">姓名</a-select-option>
							<a-select-option :value="2">手机号</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="memberWx" slot-scope="text,memberWx">
						<a-avatar :src="memberWx.wxInfo.headpic" />
						{{memberWx.wxInfo.nickname}}
						<a-icon type="man" style="color:#597ef7 ;" v-if="memberWx.wxInfo.sex == 1" />
						<a-icon style="color:#f759ab ;" type="woman" v-if="memberWx.wxInfo.sex == 2" />
					</span>
					<span slot="memberUser" slot-scope="text,memberUser">
						<div>{{memberUser.memberName}}</div>
						<div>{{memberUser.memberPhone}}</div>
					</span>
					<span slot="memberLvName" slot-scope="memberLvName">
						<a-tag color="blue">{{memberLvName}}</a-tag>
					</span>
					<span slot="memberPayMoney" slot-scope="memberPayMoney">
						{{memberPayMoney}} 元
					</span>
					<span slot="memberIntegral" slot-scope="memberIntegral">
						{{memberIntegral}} 积分
					</span>
					<span slot="memberMoney" slot-scope="memberMoney">
						{{memberMoney}} 元
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
					</span>
				</a-table>
			</div>
		</div>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '会员信息',
			dataIndex: 'memberUser',
			scopedSlots: {
				customRender: 'memberUser'
			},
		},
		{
			title: '微信信息',
			dataIndex: 'memberWx',
			scopedSlots: {
				customRender: 'memberWx'
			},
		},
		{
			title: '会员等级',
			dataIndex: 'memberLvName',
			scopedSlots: {
				customRender: 'memberLvName'
			},
		},
		{
			title: '累计消费',
			dataIndex: 'memberPayMoney',
			scopedSlots: {
				customRender: 'memberPayMoney'
			},
		},
		{
			title: '累计积分',
			dataIndex: 'memberIntegral',
			scopedSlots: {
				customRender: 'memberIntegral'
			},
		},
		{
			title: '钱包余额',
			dataIndex: 'memberMoney',
			scopedSlots: {
				customRender: 'memberMoney'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				searchForm: {
					type:1
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			toDetail(id) {
				this.$router.push('/member/memberDetail?id=' + id)
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					type: this.searchForm.type,
					word: this.searchForm.word,
				}
				this.$http.post('/admin/index.php/admin/User/memberList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
